import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'deleteComma'})
export class DeleteCommaPipe implements PipeTransform {
  transform(value: string): string {
    if(value == undefined){
      return '';
    }
    return value.replace(',','.');
  }
}
